import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../../app/store'

const initialState: any = {
  feedList: [],
  currentPage: 1,
  allPages: 0,
}

export const feedSlice = createSlice({
  name: 'feedSlice',
  initialState,
  reducers: {
    handleCurrentPage: (state, { payload }): void => {
      state.currentPage = payload
    },
    handlefeedList: (state, { payload }): void => {
      state.feedList = payload
    },
    handleAllPages: (state, { payload }): void => {
      state.allPages = payload
    },
  },
})

export const {
  handleAllPages,
  handleCurrentPage,
  handlefeedList,
} = feedSlice.actions

export default feedSlice.reducer
export const feedReducer = (state: RootState) => state.feedsReducer
